import { factory } from '@mswjs/data';
import { modelDefinitions } from './models';
import { userInfo } from '../data/userInfo';

// Create the database
const db = factory(modelDefinitions);

db.userInfo.create(userInfo);

export { db };
